import SearchDialog from '@/components/searchDialog';
import { Group, Text, UnstyledButton } from '@mantine/core';
import { spotlight } from '@mantine/spotlight';
import { IconSearch } from '@tabler/icons-react';

export default function HeaderSearch() {
  return (
    <>
      {' '}
      <UnstyledButton
        css={{
          height: 34,
          padding: '0 4px 0 var(--mantine-spacing-sm)',
          borderRadius: 'var(--mantine-radius-md)',
          color: 'var(--mantine-color-placeholder)',
          backgroundColor: 'var(--mantine-color-dark-6)',
          border: '1px solid var(--mantine-color-dark-4)',
          fontSize: 'var(--mantine-font-size-md)',
        }}
        onClick={spotlight.open}
      >
        <Group gap="sm">
          <IconSearch size="15" />
          <Text
            css={{
              paddingRight: '5rem',
            }}
          >
            Search
          </Text>
          <Text
            css={{
              padding: '4px 7px',
              fontSize: '11px',
              fontWeight: 'bold',
              lineHeight: '1',
              color: 'var(--mantine-color-dark-0)',
              backgroundColor: 'var(--mantine-color-dark-7)',
            }}
          >
            Ctrl + K
          </Text>
        </Group>
      </UnstyledButton>
      <SearchDialog />
    </>
  );
}
